import React, { useState, useContext, useEffect } from "react";
import { Table, Modal, Form, Radio, Button, Input, message, Empty } from "antd";
import { verticalFormLayout } from "../../../utils/forms";
import { RootContext } from "../../../RootContextProvider";
import { addNewTeamMember, getAccountsUsers } from "../../../utils/user";
import "../Admin.css";
import ModalUpgradeLinks from "../../Locker/ModalUpgradeLinks";

const AdminTeam = () => {
  const [form] = Form.useForm();

  const [showAddTeamMembers, setShowAddTeamMembers] = useState(false);
  const [, setAdmin] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const { user, account } = useContext(RootContext);

  form.setFieldsValue({
    Email: "",
    Role: true,
  });

  const columns = [
    {
      title: "Name",
      width: 250,
      key: "UserID",
      render: (text, record, index) => (
        <span>
          {record.FirstName} {record.LastName}
        </span>
      ),
    },
    {
      title: "Email",
      width: 300,
      dataIndex: "Email",
    },
    {
      title: "Status",
      width: 130,
      render: (text, record, index) => (
        <>
          {record.IsActivated ? (
            <span style={{ color: "#2EC4B6" }}>Active</span>
          ) : (
            <span style={{ color: "#F2994A" }}>En Attente</span>
          )}
        </>
      ),
    },
    {
      title: "Role",
      render: (text, record, index) => (
        <>{record.Admin ? "Administrateur" : "Membre"}</>
      ),
    },
  ];

  useEffect(() => {
    async function fetchData() {
      const users = await getAccountsUsers();
      setUsers(users);
      for (const _user of users) {
        if (_user.UserID === user.UserID && _user._Admin) {
          setAdmin(true);
        }
      }
    }

    fetchData();
  }, [user.UserID]);

  const cancel = () => {
    setShowAddTeamMembers(false);
  };

  const save = async (values) => {
    setLoading(true);
    try {
      const invited = {
        email: values.Email.toLowerCase(),
        _admin: values.Role,
      };
      console.log(invited);
      let team = await addNewTeamMember(invited);
      console.log(team);
      if (team.err) {
        message.error("Erreur, cet utilisateur a déjà un compte Linksight.");
      } else {
        setUsers(await getAccountsUsers());
      }
    } catch (err) {
      message.error("Erreur, veuillez nous contacter");
      return;
    } finally {
      setLoading(false);
      setShowAddTeamMembers(false);
    }
  };

  const verifyEmail = (rule, value, res) => {
    for (const user of users) {
      if (user.Email.toLowerCase() === value.toLowerCase()) {
        return res("Ce membre existe déjà !");
      }
    }
    return res();
  };

  const onFinishFailed = () => {};

  return (
    <div className="container-teammembers" style={{ marginTop: "20px" }}>
      <div className="header-settings">
        <div
          style={{
            // color: "#55575D",
            fontSize: "20px",
            display: "inline-block",
          }}
          className="third-title"
        >
          Membres de l'équipe
        </div>
        {account.Admin ? (
          <Button
            type="primary"
            style={{ float: "right", cursor: "pointer" }}
            onClick={
              account.IsPaying
                ? () => {
                    setShowAddTeamMembers(true);
                  }
                : () => {
                    setShowUpgradeModal(true);
                  }
            }
          >
            Ajouter un membre d'équipe
          </Button>
        ) : (
          ""
        )}
      </div>

      <Modal
        visible={showAddTeamMembers}
        closable={true}
        onCancel={cancel}
        // confirmLoading={loading}
        footer={null}
      >
        <div className="padding-form-invite">
          <span className="title-modal">Invitez un membre de votre équipe</span>

          <Form
            className="form-signup align-left"
            layout="vertical"
            form={form}
            onFinish={save}
            onFinishFailed={onFinishFailed}
            {...verticalFormLayout}
          >
            <Form.Item
              name="Email"
              rules={[
                { type: "email", message: "Insérez un email valide" },
                {
                  validator: verifyEmail,
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
                {
                  max: 100,
                  message: "100 caractères maximum.",
                },
              ]}
            >
              <Input className="auth-input" placeholder="jean@airbnb.com" />
            </Form.Item>
            <Form.Item
              name="Role"
              maxLength={100}
              label="Role"
              //   help={
              //     getFieldValue("role")
              //       ? "Un admin a tous les droits sur le compte."
              //       : "Un membre a tous les droits sauf la suppression d'établissements et n'a pas accès à la partie facturation."
              //   }
            >
              <Radio.Group
              // disabled={!admin}
              // defaultValue={true}
              >
                <Radio value={true}>Admin</Radio>
                <Radio value={false}>Membre</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item>
              <div className="modal-button">
                <Button
                  key="submit"
                  type="primary"
                  loading={loading}
                  htmlType="submit"
                  // disabled={!getFieldValue("Email") || hasErrors(getFieldsError())}
                >
                  Envoyer l'invitation
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </Modal>
      <Table
        dataSource={users}
        columns={columns}
        rowKey="UserID"
        pagination={false}
        locale={{
          emptyText: <Empty description="Vous n'avez aucun membre d'équipe." />,
        }}
      />
      <br />
      <ModalUpgradeLinks
        subtitle="Ajoutez toute votre équipe en passant premium."
        showUpgradeModal={showUpgradeModal}
        setShowUpgradeModal={setShowUpgradeModal}
      />
    </div>
  );
};

export default AdminTeam;
